<template>
  <b-card>
    <div class="col-sm-12">
      <h4 class="h4-title">{{text.project}}</h4>
      <b-row>
        <b-col
          class="form-group"
          cols="4"
        >
         <b-form-select v-model="selectedProject" :options="Projects"></b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          class="form-group"
          cols="2"
        >
          <button
            type="button"
            class="btn action-b-btn b-btn"
            @click="addProjectToUserResident"
          >{{text.save}}</button>
        </b-col>
        <b-col class="form-group" cols="2">
          <button
            type="button"
            class="btn btn-back b-btn"
            @click="backToProfile"
          >{{text.back}}</button>
        </b-col>
      </b-row>
      <b-row>
            <div class="col-lg-12">
              <b-alert
                variant="success"
                dismissible
                fade
                :show="saveDone"
              >
                {{successMessage}}
              </b-alert>
              <b-alert
                variant="danger"
                dismissible
                fade
                :show="saveError"
              >
                {{errorMessage}}
              </b-alert>
            </div>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import MqdcOneClient from '@/models/mqdc-one-client';
import { textUserProfiles } from '@/assets/utils/language';
export default {
  name: 'Project',
  props: ['id'],
  data () {
    return {
      selectedProject: null,
      Projects: [],
      Project: {},
      saveDone: false,
      saveError: false,
      sourceRouteName: null,
      successMessage: '',
      errorMessage: '',
      mqdcOneClient: {},
      text: {}
    };
  },
  created: function () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    document.title = 'One App: User Profile: Project';
    this.loadProjects();
    this.sourceRouteName = this.$route.name;
  },
  methods: {
    backToProfile () {
      if ('one_app_residents-project' === this.sourceRouteName) {
        this.$router.push({ name: 'one_app_residents-edit', params: { id: this.id } });
      } else if ('one_app_profiles-project' === this.sourceRouteName) {
        this.$router.push({ name: 'one_app_profiles-profile', params: { id: this.id } });
      }
    },
    async loadProjects () {
      try {
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/projects`;
        const projectsResponse = await this.mqdcOneClient.getAxios().then(axios => {
          return axios.get(
            url
          );
        });
        if (!projectsResponse) {
          this.$router.push({ name: 'one_app_profiles' });
        }
        const projects = projectsResponse.data.data;
        this.Projects.push({ value: null, text: this.text.pleaseSelect });
        projects.forEach(element => {
          this.Projects.push({ value: element.code, text: element.name });
        });
      } catch (err) {
        console.log('Error ===>>>', err);
      }
    },
    saveProjectToUser () {
      if (this.selectedProject) {
        const project = { 'projectCode': this.selectedProject };
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/users/${this.id}/projects`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.post(
              url, project).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              this.$router.push({ name: 'one_app_profiles-profile', params: { id: this.id } });
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error);
              });
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        this.$alert(
          'Please select valid project to save.',
          'Warning',
          'warning'
        ).then(() => console.log('Closed'));
      }
    },
    saveProjectToResident () {
      if (this.selectedProject) {
        const project = { 'projectCode': this.selectedProject };
        const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${this.id}/projects`;
        try {
          this.mqdcOneClient.getAxios().then(axios => {
            axios.post(
              url, project).then(response => {
              this.successMessage = response.data.message;
              this.saveDone = true;
              this.$router.push({ name: 'one_app_residents-edit', params: { id: this.id } });
            })
              .catch(error => {
                this.saveError = true;
                this.saveDone = false;
                this.successMessage = '';
                this.errorMessage = error.response.data.message;
                console.log(error);
              });
          });
        } catch (err) {
          console.log(err);
        }
      } else {
        this.$alert(
          'Please select valid project to save.',
          'Warning',
          'warning'
        ).then(() => console.log('Closed'));
      }
    },
    addProjectToUserResident () {
      if ('one_app_profiles-project' === this.sourceRouteName) {
        this.saveProjectToUser();
      } else if ('one_app_residents-project' === this.sourceRouteName) {
        this.saveProjectToResident();
      }
    }
  },
  mounted () {
    this.text = textUserProfiles(this.$language);
  },
  watch: {
    $language: function () {
      this.text = textUserProfiles(this.$language);
    }
  }
};
</script>
<style scoped src="@/assets/css/projectunit.css"></style>
